

import React, { useState, useEffect, useRef } from 'react';
import { useOrders } from '../../pages/DefaultPage/connect/Orders';


const SearchInput = ({ onSearch, isSearch, setIsSearch }) => {
    const [searchValue, setSearchValue] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [history, setHistory] = useState([]);
    const [pinned, setPinned] = useState([]);

    const { getAdsMasterSearch, getDetailMasterByQueryNew, getAuctionDetailMasterByQuery } = useOrders((state) => state.actions);
    const dropDownRef = useRef(null)
    const allSuggestions = [
        "فروش مسکونی",
        "فروش آپارتمان اداری",
        "فروش خانه و ویلا",
        "فروش زمین",
        "فروش دفتر کار",
        "فروش تجاری",
    ];

    useEffect(() => {
        // Load the last search value from localStorage on component mount
        // if (isSearch) {
        //     const savedSearchValue = localStorage.getItem('searchValue');
        //     if (savedSearchValue) {
        //         setSearchValue(savedSearchValue);
        //     }
        // } else {
        //     setSearchValue("");
        // }
        const savedSearchValue = localStorage.getItem('searchValue');
            if (savedSearchValue) {
                setSearchValue(savedSearchValue);
            }
        // Load search history from localStorage on component mount
        const savedHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];
        setHistory(savedHistory);

        // Load pinned suggestions from localStorage on component mount
        const savedPinned = JSON.parse(localStorage.getItem('pinnedSuggestions')) || [];
        setPinned(savedPinned);

        document.addEventListener('click', handleClickOutside);

        // Cleanup the event listener on component unmount
        return () => {
            document.removeEventListener('click', handleClickOutside);
        }
    }, []);
    // console.log("ljkljkl" , searchValue);
    console.log("ljkljkl-------", setIsSearch);
    // console.log("ljkljkl5555" , localStorage.getItem("searchValue"));



    const handleClickOutside = (event) => {
        if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
            setSuggestions([]);
            // console.log("outside");

        }
    };
    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchValue(value);

        // Save current input value to localStorage
        // localStorage.setItem('searchValue', value);

        // Show suggestions if "فروش" is in the input value
        if (value.includes("فروش")) {
            setSuggestions(allSuggestions.filter(suggestion => suggestion.includes(value)));
        } else {
            setSuggestions([]);
        }

        if (value.trim() === "") {
            localStorage.removeItem('searchValue' );// Clear localStorage when input is empty
        } else {
            localStorage.setItem('searchValue', value); // Save value to localStorage
        }
    };

    const handleFocus = () => {
        // Show search history when input is focused, with pinned items at the top
        if (history.length > 0 || pinned.length > 0) {
            const combinedSuggestions = [...pinned, ...history.filter(item => !pinned.includes(item))];
            setSuggestions(combinedSuggestions);
        }
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        // setIsSearch(true)
        if (searchValue.length > 2) {
            onSearch(searchValue);
            // getAdsMasterSearch(searchValue, 0);
            setSuggestions([]); // Clear suggestions after searching

            // Save search to history
            const updatedHistory = [searchValue, ...history.filter(item => item !== searchValue)].slice(0, 8); // Max 8 items
            setHistory(updatedHistory);
            localStorage.setItem('searchHistory', JSON.stringify(updatedHistory));
        }
    };
    const clickedOnSuggestion = (suggestion) => {
        // getAdsMasterSearch(suggestion, 0);
   
    }
    const clearHistory = () => {
        localStorage.removeItem('searchHistory');
        setHistory([]);
        setSuggestions(pinned); // Keep pinned items visible
    };

    const handlePin = (suggestion) => {
        const updatedPinned = [suggestion, ...pinned.filter(item => item !== suggestion)];
        setPinned(updatedPinned);
        localStorage.setItem('pinnedSuggestions', JSON.stringify(updatedPinned));
    };

    const handleUnpin = (suggestion) => {
        const updatedPinned = pinned.filter(item => item !== suggestion);
        setPinned(updatedPinned);
        localStorage.setItem('pinnedSuggestions', JSON.stringify(updatedPinned));
    };
    const handleRemove = (suggestion) => {
        const updatedHistory = history.filter(item => item !== suggestion);
        setHistory(updatedHistory);
        localStorage.setItem('searchHistory', JSON.stringify(updatedHistory));

        // Update suggestions to reflect the change
        setSuggestions(prevSuggestions => prevSuggestions.filter(item => item !== suggestion));
    };
    return (
        <div ref={dropDownRef} className='w-full relative flex items-center rounded-md border border-1 '>
            <div className="flex items-center w-full md:relative">
                <img src="/icons/LogoInSearch.svg" className='pr-1 px-2' alt="icon" />
                <form onSubmit={handleSubmit}>
                    <div className='flex items-center w-full'>
                        <input
                            onChange={handleInputChange}
                            onFocus={handleFocus}
                            value={searchValue}
                            className='w-full texr-sm bg-transparent border-none outline-none transition-all duration-700'
                            type="text"
                            placeholder="جست و جو"
                        />
                    </div>
                    <button className="absolute w-6 h-6 left-2 top-[5px] ">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                        </svg>
                    </button>
                </form>

                {/* Display suggestions and history */}
                {suggestions.length > 0 && (
                    <ul className="absolute top-full mt-2 left-0 w-full bg-white border border-gray-300 rounded-md shadow-lg">
                        <p className='text-[#B90023] text-sm m-1 text-end ' onClick={() => clearHistory()}>حذف تاریخچه جست و جو </p>
                        {suggestions.map((suggestion, index) => (
                            <li key={index} className="px-4 py-2 flex items-center justify-between cursor-pointer hover:bg-gray-100">
                                <span
                                    onClick={(e) => {
                                        setSearchValue(suggestion);
                                        localStorage.setItem('searchValue', suggestion); // Save selected suggestion to localStorage
                                        setSuggestions([]); // Clear suggestions after selection
                                        clickedOnSuggestion(suggestion)
                                    }}
                                >
                                    {suggestion}
                                </span>
                                <div className='flex '>
                                    {pinned.includes(suggestion) ? (
                                        <img src='/icons/green-pin.svg' alt='Unpin' onClick={() => handleUnpin(suggestion)} />
                                    ) : (
                                        <img src='/icons/gray-unpin.svg' alt='Pin' onClick={() => handlePin(suggestion)} />
                                    )}
                                    <img
                                        src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor' strokeWidth='2'%3E%3Cpath strokeLinecap='round' strokeLinejoin='round' d='M6 18L18 6M6 6l12 12' /%3E%3C/svg%3E"
                                        alt="Close"
                                        className="w-4 h-4 cursor-pointer mr-1"
                                        onClick={() => handleRemove(suggestion)}
                                    />
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default SearchInput;
